export const MEMBERS_ALSO_LIKED_EXP_FLAG = 'pen-4715_v1'

export const MEMBERS_ALSO_LIKED_EXP_PIXEL_FLAG = 'pen-4715_v1_pixel'
